export default {
    label_task:{
        en:"Dealers Payment",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Dealer Payment",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Dealer Payment",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Dealer Payment",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_payment_at:{
        en:"Payment Date",
        bn:"কর্মচারী আইডি"
    },

}